/* eslint-disable */
var Analytics = require('./analytics.js');
var Promise = window.Promise || require('promise-polyfill');
var dataLayerUtils = require('@dc/data-layer/src/utils.js');

var GOOGLE_PLACES_URL = "https://maps.googleapis.com/maps/api/js?libraries=places";
var GOOGLE_CLIENT_API_KEY = "client=gme-dsgretaillimited2";

var LOCALSTORAGE_LOCATION_HISTORY_ANON = "LocationService.History.Anonymous";
var LOCALSTORAGE_LOCATION_HISTORY_SESSION = "LocationService.History.Session";

var regularExpressions = require('@dc/ui-library/src/config/regularExpressions/index').default;
var resolveByCountry = require('@dc/ui-library/src/helpers/environment').resolveByCountry;

var LocationStatus = require('./locationstatus.js');

var listingPageDucks = require('./appState/ducks/listingPageSetup.js');

function getLocalStorageKey() {
  return window.App.settings.get('userDetails') ?
    LOCALSTORAGE_LOCATION_HISTORY_SESSION : LOCALSTORAGE_LOCATION_HISTORY_ANON;
}

/** @namespace */
/** @implements EventTarget */
var LocationService = {
  __events : {},

  /** @param {string} type */
  /** @param {function} listener */
  /** @param {boolean} [useCapture] */
  /** @returns {void} */
  addEventListener : function(type, listener, useCapture){
    if(this.__events[type] === undefined) {
      this.__events[type] = [];
    }
    this.__events[type].push({"listener" : listener, "useCapture" : useCapture});
  },

  /** @param {string} type */
  /** @param {function} listener */
  /** @param {boolean} [useCapture] */
  /** @returns {void} */
  removeEventListener : function(type, listener, useCapture){
    if(this.__events[type] === undefined) return;
    for(var i = 0; i < this.__events[type].length; i++){
      var registered = this.__events[type][i];
      if(registered.listener === listener && registered.useCapture === useCapture){
        this.__events[type].splice(i, 1);
      }
    }
  },

  /** @param {Event} event */
  /** @returns {void} */
  dispatchEvent : function(event){
    // We're not cancellable and we don't bubble;
    if(this.__events[event.type] === undefined) return;
    for(var i = 0; i < this.__events[event.type].length; i++){
      var fn = this.__events[event.type][i].listener;
      setTimeout(fn.bind(fn, event), 0);
    }
  },

  /** @private */
  __locationRequest : null,

  /** @private */
  __currentLocation : null,

  /** @private */
  __locationState : null,

  /** @private */
  __previousLocations : [],

  /** @property {array}
    @description Default location restrictions. Full display restrictions currently removed for the "Staples Corner" issue
    ["establishment", "premise", "transit_station", "route", "administrative_area_level_3", "administrative_area_level_2"]; */
  defaultRestrictions : ["premise", "administrative_area_level_3", "administrative_area_level_2"],

  /** @property {Boolean} Should debug messages be enabled */
  debug : false,

  /** @param {string} term
    @param {string} [searchtype]
    @param {Array} [restrictions]
    @returns {Promise<Array>}
    @description Returns an array of valid LocationDescriptors based on the search term */
  search : function(term, searchtype, restrictions){
    var self = this;
    this.__locationRequest.input = term;
    this.__locationRequest.types = searchtype ? [searchtype] : ["(regions)"];

    return new Promise(function(resolve, reject){
      var serchResulsFoundDescriptor = new LocationDescriptor();
      var descriptor = new LocationDescriptor();
      serchResulsFoundDescriptor.term = term;
      descriptor.term = term;
      function onresult(predictions, status){
        if(status === "OK"){
          var locations = self.getLocations(term, predictions, restrictions);
          var locationState = locations.length > 0 ? LocationService.LocationState.READY : LocationService.LocationState.INVALID;
          if (locationState === LocationService.LocationState.READY) {
            serchResulsFoundDescriptor.status = LocationService.LocationState.SEARCH_RESULTS_FOUND
            self.__dispatchStateChange(LocationService.LocationState.SEARCH_RESULTS_FOUND, status, serchResulsFoundDescriptor, locations);
          }
          self.__dispatchStateChange(locationState, status, descriptor);
          resolve(locations);
        }
        else {
          self.__dispatchStateChange(LocationService.LocationState.INVALID, status, descriptor);
          reject(status);
        }
      }
      self.__dispatchStateChange(LocationService.LocationState.SEARCHING, "", descriptor);
      self.__autocompleteService.getPlacePredictions(self.__locationRequest, onresult);
    });
  },

  /** @param {LocationDescriptor} descriptor
    @returns {Promise}
    @description Resolve to the Postcode & LatLong of the LocationDescriptor */
  resolveLocation : function(descriptor){
    this.__dispatchStateChange(LocationService.LocationState.RESOLVING, "", descriptor);
    var self = this;
    return new Promise(function(resolve, reject){
      if(descriptor.postcode){
        // We (wrongly) assume that the postcode is always valid and resolve() immediately
        // We probably want to expand a postcode only descriptor to get a full validated location & description...
        self.__dispatchStateChange(LocationService.LocationState.READY, "", descriptor);
        resolve(descriptor);
        return;
      } else if(descriptor.coords.length > 0){
        getPostCode().then(
          function() {
            self.__dispatchStateChange(LocationService.LocationState.READY, "", descriptor);
            resolve(descriptor);
          },
          function(reason) {
            self.__dispatchStateChange(LocationService.LocationState.ERROR, reason, descriptor);
            reject(reason);
          });
        return;
      }

      function resolveLatLong(results, status){
        if(status === window.google.maps.GeocoderStatus.OK){
          var geometry = results[0].geometry;
          descriptor.coords.push(parseFloat(geometry.location.lat()));
          descriptor.coords.push(parseFloat(geometry.location.lng()));
          resolve(getPostCode());
        } else {
          reject("Error Geocoding PlaceId: " +descriptor.id, status);
        }
      }

      var geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({placeId : descriptor.id}, resolveLatLong);
    });


    function getPostCode(){
      return new Promise(function(resolve, reject){
        var geocoder = new window.google.maps.Geocoder();

        /** @description Google Geocode callback for trying to get postcode from geocode search results
          @param {Array} results
          @param {google.maps.GeocoderStatus} status
          @returns {void} */
        function parseGeocodeResultsForGatheringPostcode(results, status){
          if(status === google.maps.GeocoderStatus.OK){

            // Try to find a specific postcode for this location from postal code result ("postal_code")
            // or from nearby address result ("street_address")
            // or from nearby route result ("route")
            tryToGatherPostcodeFromGeocodeResponse(results, "postal_code") ||
            tryToGatherPostcodeFromGeocodeResponse(results, "street_address") ||
            tryToGatherPostcodeFromGeocodeResponse(results, "route");

            if(descriptor.postcode || resolveByCountry(false, true)) {
              // if the postcode is found this Promise is resolved
              // if the current page is Ireland page, this Promise is also resolved
              // because Ireland postcode (eircode) is not required by PHP server web servicesfor Ireland so it's not necessary to send it
              resolve(descriptor);
            } else {
              // This is fallback for UK Currys/PC World where postcode is required for PHP web services
              // The postcode doesn't have to be found by previous code in some rare cases (3% of all UK locations)
              // If it happens, we try to gather postcode by finding the nearest Post Office for this location
              // beacause every UK Post Office should have postcode
              getPostCodeOfTheNearestPostOffice();
            }
          } else {
            reject("Error Geocoding Location: " +status);
          }
        }

        /** @description parse the array of Google Geocode addresses in order
         * to try gather UK postcode. if it finds postcode it saves the postcode to descriptor.postcode
         @param {Array} results
         @param {string} type Address Type
         @returns {boolean} true - postcode was found
                            false - postcode wasn't found
         */
        function tryToGatherPostcodeFromGeocodeResponse(results, type) {
          for(var i = 0; i < results.length; i++) {
            if(results[i].types.indexOf(type) !== -1) {
              var components = results[i].address_components;
              for(var j = 0; j < components.length; j++) {
                if(components[j].types[0] === "postal_code" &&  // We only want a type that is exactly a postcode
                  components[j].types.length === 1) { // in order to eliminate postcode prefixes in case of "types" : [ "postal_code", "postal_code_prefix" ]
                  descriptor.postcode = components[j].long_name;
                  break;
                }
              }
              if(descriptor.postcode) {
                if(!descriptor.location) {   // Assign postcode as location string if none exists
                  descriptor.location = descriptor.postcode;
                }
                return true;
              }
              return false;
            }
          }
        }

        /**
         * Try to find nearest post office for this location using Google Maps API and gather postcode from it
         * beacause every UK Post Office should have postcode.
         */
        function getPostCodeOfTheNearestPostOffice() {
          var placesService = new window.google.maps.places.PlacesService(document.createElement('div'));

          var placesServiceRequest = {
            location : new window.google.maps.LatLng(descriptor.coords[0], descriptor.coords[1]),
            radius: 2000,
            type: ['post_office']
          };

          // following method searches for the nearest post office of the current location
          // in case of error current promise is rejected
          placesService.nearbySearch(placesServiceRequest, function callback(results, status) {
            if (status === window.google.maps.places.PlacesServiceStatus.OK) {
              var geoPostOfficeRequest = {
                placeId: results[0].place_id
              };

              // if post office is found we gather postcode from this post office by reverse geocode call
              // if postcode is found, it's added to descriptor.postcode and Promise is resloved
              // if not found Promise is rejected
              geocoder.geocode(geoPostOfficeRequest, function callback(results, status) {
                if(status === google.maps.GeocoderStatus.OK){
                  for(var i = 0; i < results[0].address_components.length; i++) {
                    var currentAddressComponent = results[0].address_components[i];

                    if(currentAddressComponent.types[0] === "postal_code" &&  // We only want a type that is exactly a postcode
                      currentAddressComponent.types.length === 1) { // in order to eliminate postcode prefixes in case of "types" : [ "postal_code", "postal_code_prefix" ]
                      descriptor.postcode = currentAddressComponent.long_name;
                      resolve(descriptor);
                      return;
                    }
                  }
                  reject("Error finding postcode using Geolocation: " + status);
                } else {
                  reject("Error finding postcode using Geolocation: " + status);
                }

              });
            } else {
              reject("Error finding post office for gathering postcode: " + status);
            }
          });
        }

        var geoRequest = {
          location : {
            lat : descriptor.coords[0],
            lng : descriptor.coords[1]
          }
        };

        // Finds geocode addresses for gathering postcode. Google JS API reverse geocoding is used
        geocoder.geocode(geoRequest, parseGeocodeResultsForGatheringPostcode);
      });
    }

  },

  /** @param {string} term
    @param {Array<Object>} predictions
    @param {Array<string>} restrictions
    @returns {Array<LocationDescriptors>}
    @description Return an array of valid LocationsDescriptors from Google Places predictions */
  getLocations : function(term, predictions, restrictions){
    var descriptors = [];
    for(var i = 0; i < predictions.length; i++) {
      var descriptor = new LocationDescriptor(term, predictions[i]);
      var restricted = false;
      if(restrictions.length > 0 && !descriptor.retailLocation){
        for(var t = 0; t < descriptor.types.length; t++){
          if(restrictions.indexOf(descriptor.types[t]) !== -1){
            restricted = true;
            break;
          }
        }
      }
      if(!restricted){
        descriptors.push(descriptor);
      }
      else if(this.debug) {
        console.info("Restricting Location:", descriptor.location, descriptor.description);
      }
    }
    return descriptors;
  },

  /** @returns {Array<LocationDescriptor>}
    @description Returns an Array of previously store LocationDescriptors */
  getPreviousLocations : function(){
    // the clone of previous locations is returned
    // because it's stored in redux store
    return Array.from(
      this.__previousLocations, function(descriptor) {
        var clonedDescriptor = Object.assign({}, descriptor);
        Object.setPrototypeOf(clonedDescriptor, LocationDescriptor.prototype);

        return clonedDescriptor;
      }
    );
  },

  /** @param {LocationDescriptor} descriptor
    @returns {void}
    @description Update the location history with a new descriptor & save to LocalStorage */
  updateLocationHistory : function(descriptor){
    var previouslyUsed;
    var descriptorPostcode;

    // It's necessary to clone this.__previousLocations
    // because some it's taken from immutable redux store
    this.__previousLocations = Array.from(
      this.__previousLocations, function(descriptor) {
        var clonedDescriptor = Object.assign({}, descriptor);
        Object.setPrototypeOf(clonedDescriptor, LocationDescriptor.prototype);

        return clonedDescriptor;
      }
    );

    descriptorPostcode = descriptor.postcode.replace(/\s/g, '');
    for (var i = 0; i < this.__previousLocations.length; i++) {
      if (descriptor.id && (this.__previousLocations[i].id === descriptor.id) ||
        this.__previousLocations[i].postcode.replace(/\s/g, '') === descriptorPostcode) {
        previouslyUsed = this.__previousLocations.splice(i, 1)[0];
      }
    }
    if(this.__previousLocations.length === 5){
      this.__previousLocations.pop();
    }
    descriptor.source = LocationService.LocationSource.HISTORY;
    this.__previousLocations.unshift(previouslyUsed || descriptor);
    var history = JSON.stringify(this.__previousLocations);
    var storageKey = getLocalStorageKey();
    try {
      window.localStorage.setItem(storageKey, history);
    }
    catch(e){}
  },

  /** @returns {void}
    @description Restore the location history from LocalStorage */
  restoreLocationHistory : function(){
    this.__previousLocations = [];
    var storageKey = getLocalStorageKey();
    try {
      var history = window.localStorage.getItem(storageKey);
    }
    catch(e){
      return;
    }
    history = JSON.parse(history) || [];
    for(var i = 0; i < history.length; i++){
      var descriptor = new LocationDescriptor();
      descriptor.setData(history[i]);
      this.__previousLocations.push(descriptor);
    }
  },

  /** @returns {void}
    @description Clear the location history from LocalStorage */
  clearLocationHistory : function(){
    this.__previousLocations = [];
    var history = JSON.stringify(this.__previousLocations);
    var storageKey = getLocalStorageKey();
    try {
      window.localStorage.setItem(storageKey, history);
    }
    catch(e){}
  },

  /** @param {Array} [coords]
    @param {string} [postcode]
    @param {string} [description]
    @returns {LocationDescriptor}
    @description Initialise a new location */
  createLocation : function(coords, postcode, description){
    var descriptor = new LocationDescriptor();
    descriptor.coords = coords || [];
    descriptor.location = descriptor.postcode = postcode || "";
    descriptor.description = description || "";
    return descriptor;
  },

  /** @returns {LocationService.LocationState} */
  getLocationState : function(){
    return this.__locationState;
  },

  /** @returns {LocationDescriptor}
    @description Get the current location */
  getLocation : function(){
    return this.__currentLocation;
  },

  /** @returns {Promise<LocationDescriptor>}
    @description Get the currently resolved geolocation */
  getGeoLocation : function(){
    var self = this;
    return new Promise(function(resolve, reject){
      if(!window.App.Platform.Supports.geolocation()){
        reject("Geolocation not available");
      }
      function onsuccess(position){
        var coords = [position.coords.latitude, position.coords.longitude];
        var location = LocationService.createLocation(coords);
        location.source = LocationService.LocationSource.GEOLOCATION;
        resolve(location);  // Resolving the Promise not the Location!
      }
      function onerror(positionError){
        reject(positionError.message);
      }
      var options = {
        enableHighAccuracy : true,
        timeout : 10000
      }
      navigator.geolocation.getCurrentPosition(onsuccess, onerror, options);
    });
  },

  /**
   * Populate locationservice for the automatic stock checker
   * Won't check/search anything, just create "fake" LocationDescriptor and set it as currentLocation
   * and fire AUTOMATIC_STOCK_CHECKER analytics event
   * @param {String} postCode
   */
  setAutomaticStockChecker: function(postCode) {
    var locationDescriptor = this.createLocation([], postCode);
    this.__currentLocation = locationDescriptor;
    var dtmEvent = {
      eventInfo: {
        eventName: 'Postcode Checker',
        eventAction: 'Interactive',
        eventAttribute: {
          locationChange: {
            source: 'SESSION',
            location: postCode,
            postcode: postCode,
            exact: true,
            status: 'COMPLETED'
          }
        }
      }
    };

    Analytics.track("AUTOMATIC_STOCK_CHECKER", postCode);
  },

  onEndLocation: function(statusObj){
    var status;
    var statusText;

    if (statusObj instanceof LocationStatus == false) {
      // here we end up when the statusObj is not LocationStatus nor valid Error
      // Info goes to console and the component state is set to FAILED
      console.warn('onEndLocation called with statusObj of unknown type: ', statusObj);

      this.__dispatchStateChange(
        LocationService.LocationState.FAILED,
        'LocationService :: Location Change Failed with statusObj of unknown type.',
        this.getLocation());
      return;
    }

    // at this pont everything should be ready to handle valid location search errors
    status = statusObj.status;
    statusText = statusObj.statusText;

    if(status !== LocationService.LocationState.COMPLETE) {
      console.warn("LocationService :: Location Change Failed:", status);
      if(status === LocationService.LocationState.TIMEOUT){
        // Dispatch a FAILED state on TIMEOUT as server is unavailable
        status = LocationService.LocationState.FAILED;
      } else {
        status = LocationService.LocationState.ERROR;
      }
    }
    this.__dispatchStateChange(status, statusText, this.getLocation());
  },

  getTimeoutPromise: function() {
    // fallback timeout of 15 secs
    var postcodeCheckerTimeout =
        window.App.settings.get("component.mcd.postcodechecker.timeout") || 15000;

    return new Promise(function(resolve){
        setTimeout(function(){
            resolve(new LocationStatus(LocationService.LocationState.TIMEOUT, ''))
          }, postcodeCheckerTimeout
        );
    });
  },

  /**
   * Change the current location and call the underlying location provider
   * @param {LocationDescriptor} descriptor
   * @returns {void}
   */
  setLocation : function(descriptor){
    var self = this;

    this.resolveLocation(descriptor).then(
      function(){
        console.info("Resolved Location to:", descriptor.location, descriptor.description, descriptor.postcode);

        self.__currentLocation = descriptor;
        self.__dispatchStateChange(LocationService.LocationState.PENDING, "", descriptor);

        var timeout = self.getTimeoutPromise();

        var request = new Promise(function(resolve, reject){
          self.changeLocation(descriptor, timeout).then(
              function(){ resolve(new LocationStatus(LocationService.LocationState.COMPLETE, '')) },
              reject
          );
        });

        Promise.race([request, timeout]).then(
            self.onEndLocation.bind(self),
            self.onEndLocation.bind(self)
        );
      },
      self.onEndLocation
    ).catch(function (reason) {
      console.error(reason);
    });
  },

  searchCurrentLocationDescriptor: function() {
    if(!this.getLocation()) {
      return false;
    }

    var self = this;

    this.__dispatchStateChange(LocationService.LocationState.PENDING, "", this.getLocation());
    const timeout = self.getTimeoutPromise();

    var request = new Promise(function(resolve, reject){
      self.changeLocation(self.getLocation(), timeout).then(
        () => {
          resolve(new LocationStatus(LocationService.LocationState.COMPLETE, ''))
        },
        reject
      );
    });

    Promise.race([request, timeout]).then(
        self.onEndLocation.bind(self),
        self.onEndLocation.bind(self)
    );
  },

  /** @returns {void}
    @description Clear the currently set location & dispatch a "clearlocation" event
    @ignoreUserInteraction {Boolean} if set to TRUE, the UILocationSearch component will ignore its __isInUserInteraction flag */
  clearLocation : function(ignoreUserInteraction){
    var event = {
      target : this,
      type : "clearlocation",
      detail : this.getLocation(),
      ignoreUserInteraction : ignoreUserInteraction
    };
    this.__currentLocation = null;
    this.dispatchEvent(event);

    this.__dispatchStateChange(LocationService.LocationState.READY, "clearlocation", new LocationDescriptor());
  },

  /** @param {LocationDescriptor} descriptor
    @returns {Promise}
    @description The update function to call when a location is being changed */
  changeLocation : function(descriptor){
    var error = "No 'changeLocation()' handler assigned to the LocationService.";
    return new Promise(function(resolve, reject){
      setTimeout(reject.bind(reject, error),3000);
    })
  },

  /**
   * Load the Google Places API
   * @param  {string} postcode Initialize the service with this postcode
   */
  load : function(postcode){
    if(this.__locationState !== null) return;

    this.__locationState = LocationService.LocationState.LOADING;

    var initialDescriptor = new LocationDescriptor();

    this.restoreLocationHistory();

    // If a postcode has been supplied, create a descriptor for it and update
    // the location history with this descriptor
    // This is the case when a groupcall sets the initial postcode for a logged-in user.
    // We need the forced postcode to be searchable by clicking the magnifier glass icon
    if (postcode) {
      postcode = postcode.replace(regularExpressions.POST_CODE, "$1 $2");

      initialDescriptor = this.createLocation(postcode);
      initialDescriptor.exact = true;
      initialDescriptor.location = postcode;
      initialDescriptor.postcode = postcode;
      initialDescriptor.status = "COMPLETE";

      this.updateLocationHistory(initialDescriptor);
    }

    this.__dispatchStateChange(this.__locationState, "", initialDescriptor);

    window.GoogleAPIReady = function GoogleAPIReady(){
      LocationService.onready();
    };

    window.gm_authFailure = (function () {
      this.__dispatchStateChange(
        LocationService.LocationState.FAILED,
        '',
        new LocationDescriptor()
      );
    }).bind(this);

    var script = document.createElement("SCRIPT");
    script.setAttribute("type", "text/javascript");
    script.setAttribute("async", true);
    script.setAttribute("defer", true);
    script.src = GOOGLE_PLACES_URL +"&callback=GoogleAPIReady&" +GOOGLE_CLIENT_API_KEY;
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(script);
  },

  /** @returns {void}
    @description Dispatched when the Location Service is loaded and ready */
  onready : function(){
    this.__locationState = LocationService.LocationState.LOADED;
    this.__dispatchStateChange(this.__locationState, "", new LocationDescriptor());

    /* @see: https://developers.google.com/maps/documentation/javascript/reference#AutocompleteService */
    this.__locationRequest = {
      input : "",
      location : new window.google.maps.LatLng({lat: 0, lng: 0}),
      radius : "20000000",
      componentRestrictions : {country : resolveByCountry(['uk', 'im'], 'irl')},
      language : resolveByCountry("en-GB", "en-ie"),
      types : []
    };

    this.__autocompleteService = new window.google.maps.places.AutocompleteService();
    this.__locationState = LocationService.LocationState.READY;
    this.__dispatchStateChange(this.__locationState, "", new LocationDescriptor());
  },

  /** @param {LocationService.LocationState} locationState
    @param {string} statusText
    @param {LocationDescriptor} descriptor
    @param {array} locations
    @returns {void}
    @description Dispatched when the LocationService changes state */
  __dispatchStateChange : function(locationState, statusText, descriptor, locations){

    descriptor.status = locationState;
    descriptor.statusText = statusText;
    this.__locationState = locationState;
    var event = {
      target : this,
      type : "locationstatechange",
      detail : descriptor,
      locations : locations ? locations : null
    };
    this.dispatchEvent(event);
    if(locationState === LocationService.LocationState.ERROR){
        Analytics.track('LOCATION_STATE_ERROR', descriptor);
    } else if(locationState === LocationService.LocationState.COMPLETE) {
        this.updateLocationHistory(descriptor);
        var dtmEvent = {
            eventInfo: {
                eventName: "Poscode Checker",
                eventAction: "Interactive",
                eventAttribute: descriptor
            }
        };

        window.appState.dispatch({ type: 'EVENTS_POSTCODE_CHECK_INITIATED', payload: { location: descriptor.location } });
        dataLayerUtils.satelliteTrack("locationcomplete");
    }
    if(this.debug) console.info("Location Service State Change: " +locationState, descriptor);
  }
}




/** @enum {string} */
LocationService.LocationState = {
  LOADING : "LOADING",
  LOADED : "LOADED",
  READY : "READY",
  SEARCHING : "SEARCHING",
  SEARCH_RESULTS_FOUND: "SEARCH_RESULTS_FOUND",
  RESOLVING : "RESOLVING",
  INVALID : "INVALID",
  PENDING : "PENDING",
  COMPLETE : "COMPLETE",
  ERROR : "ERROR",
  TIMEOUT : "TIMEOUT",
  /** Designed to allow the LocationService to dispatch a permanantly failed status to its listeners */
  FAILED : "FAILED"
}

/** @enum {string} */
LocationService.LocationSource = {
  /** @description The location is unknown/unavailable */
  UNKNOWN : "UNKNOWN",

  /** @description The location is for the current user session */
  SESSION : "SESSION",

  /** @description The location is from device geolocation */
  GEOLOCATION : "GEOLOCATION",

  /** @description The location is from user interaction */
  INTERACTIVE : "INTERACTIVE",

  /** @description The location is from a previously used location - Not Currently Implemented */
  HISTORY : "HISTORY",

  /** @description The location is from a user favourite location - Not Currently Implemented */
  FAVOURITE : "FAVOURITE"
}

/** @constructor
  @param {string} term
  @param {object} prediction Google Places prediction object */
function LocationDescriptor(searchTerm, prediction){
  if(!prediction){    // Nothing to parse
    return;
  }
  this.coords = [];
  this.term = searchTerm;
  this.id = prediction.place_id;
  this.types = prediction.types;
  this.useCase = { page: "", description: "" };

  var descriptions = [];   // Any term after the actual matched search string

  searchTerm = searchTerm.toLowerCase();
  for(var i = 0; i < prediction.terms.length; i++){
    var term = prediction.terms[i].value.toLowerCase();
    // Find the prediction that exactly matches the search term or use as a description
    if(!this.location && term >= parseInt(searchTerm)){ // Intentional typecast
      // If the searchTerm begins with a number, we assume we've matched a street address number - try to expand it.
      // Eg. "45" >= parseInt("450 Fulham Road")
      this.location = prediction.terms[i].value +" " +prediction.terms[i +1].value || "";
      this.types = ["street_address"];
    }
    else if(!this.location && term.indexOf(searchTerm) === 0){
      // Eg. String("45  oxford street").indexOf("45 oxf") === 0
      this.location = prediction.terms[i].value;
      // If the matched search term begins with a number, again we assume a numbered street address
      if(!isNaN(parseInt(searchTerm))){
        this.types = ["street_address"];
      }
    }
    else {
      descriptions.push(prediction.terms[i].value);
    }
  }

  if(this.location === ""){
    // If no term exactly matches we assume a non-exact match against the first term
    this.location = prediction.terms[0].value
    descriptions.shift(); // Drop first description as we use the first one for location
    this.exact = false;
  }

  this.description = descriptions.join(", ");

  // Is this a store location?
  if(prediction.types.indexOf('premise') !== -1){
    var location = this.location.toLowerCase();
    for(var i = 0; i < this.__retailLocations.length; i++){
      if(location.indexOf(this.__retailLocations[i]) !== -1){
        this.retailLocation = true;
        break;
      }
    }
  }
}
LocationDescriptor.prototype = {
  /* @description These are some of the strings used to describe store names in Google maps.
    It is used as a way to try and identify a Google "establishment" or "premise" as being a company store location. */
  __retailLocations : ["currys", "pc world", "pcworld","p c world", "carphone"],

  id : "",

  exact : true,

  retailLocation : false,

  /** @description The search term matched */
  term : "",

  /** @description lat/long co-ordinates
    @type {Array<Number>} */
  coords : null,

  /** @description A description of the location */
  description : "",

  /** @description The postcode of the location */
  postcode : "",

  /** @description The matched location */
  location : "",

  /** @description The array of address component types
    @see: https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes */
  types : [],

  /** @description Current status of the Descriptor */
  status : "",

  /** @description Any textual description of the status such as error messages */
  statusText : "",

  /** @description What is the source of this location
    @type {LocationService.LocationSource} */
  source : LocationService.LocationSource.UNKNOWN,

  /** @type {Object} Keeps page type + detailed description for analytics purposes */
  useCase : {},

  /** @returns {object} */
  getData : function(){
    return {
      id : this.id,
      exact : this.exact,
      term : this.term,
      location : this.location,
      description : this.description,
      postcode : this.postcode,
      coords : this.coords,
      retailLocation : this.retailLocation,
      status : this.status,
      source : this.source
    }
  },

  /** @param {object} data
    @returns {void} */
  setData : function(data){
    for(var key in data){
      if(data.hasOwnProperty(key) && this[key] !== undefined){
        this[key] = data[key];
      }
    }
  },

  /** @description Returns a serialisable data object for JSON.stringify()
    @returns {string} */
  toJSON : function(){
    return this.getData();
  },

  /** @description Serialise the descriptor to JSON
    @returns {string} */
  toString : function(){
    return JSON.stringify(this);
  }
};

module.exports = LocationService;
